module.exports = __webpack_public_path__ + "img/private-deck.245ad290.jpg";